<button type="button" class="btn" [ngClass]="btnClass" [hidden]="btnIsHidden" (click)="reloadAndShow()">ARCHIVES</button>

<kendo-window [(state)]="WindowOptions.state" *ngIf="WindowOptions.visible"
[(width)]="WindowOptions.width" [top]="WindowOptions.top" [(height)]="WindowOptions.height" (close)="showWindow(false)">

<kendo-window-titlebar class="bg-warning">
    <div class="k-window-title text-center">
        <paflabel class="control-label" lblCod="Historique_des_documents"></paflabel>
    </div>
    <button kendoWindowCloseAction></button>
</kendo-window-titlebar>
<div class="d-flex flex-column justify-content-center" style="height:100%;width:100%;">
    <div class="card">
        <div class="card-body">
            <kendo-grid 
                [data]="lstDatas" 
                [height]="600" 
                [group]="groups" 
                (groupChange)="groupChange($event)">

                <kendo-grid-column [width]="0" field="DocTypLib" title="Type de document">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem"></ng-template>
                    <ng-template kendoGridGroupHeaderTemplate let-value="value">
                        <H6 class="control-label">{{value}}</H6>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="0" field="RefDocLib" title="Nom de document">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem"></ng-template>
                    <ng-template kendoGridGroupHeaderTemplate let-value="value">
                        <label>{{value}}</label>
                    </ng-template>
                    <!-- <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <a class="control-label" href="javascript:void(0);" (click)="btnDownloadFileClick(dataItem)" [paftooltip]="'Telecharger_le_fichier'">{{dataItem.RefDocLib}}</a>    
                    </ng-template> -->
                </kendo-grid-column>
                <kendo-grid-column field="Filename" title="Nom du fichier">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <a *ngIf="dataItem.IsMissing==0" class="control-label" href="javascript:void(0);" (click)="btnDownloadFileClick(dataItem)" [paftooltip]="'Telecharger_le_fichier'">{{dataItem.Filename}}</a>    
                        <label *ngIf="dataItem.IsMissing==1" class="control-label text-danger" [paftooltip]="'Fichier_manquant'">{{dataItem.Filename}}</label>
                    </ng-template>
                </kendo-grid-column>                
                <kendo-grid-column field="DateCrea" title="Déposé le" [width]="150" [format]="{ date: 'shortDate' }"></kendo-grid-column>
                <kendo-grid-column field="DateExpi" title="Expire le" [width]="150" [format]="{ date: 'shortDate' }"></kendo-grid-column>
                <kendo-grid-column field="StatutDate" title="Archivé le" [width]="150" [format]="{ date: 'shortDate' }"></kendo-grid-column>
            </kendo-grid>       
        </div>
    </div>
    <div style="width:100%;" class="text-center my-2">
        <button type="button" paflabel="Fermer" class="btn btn-sm btn-primary my-1"
            (click)="showWindow(false)"></button>
    </div>
</div>
<!-- <PRE *ngIf="sharedDataSvc.debug">
    lstButtonMotifs : {{lstButtonMotifs | json}}
</PRE> -->
</kendo-window>